var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 77",
    overflow: "scroll",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    fill: "#82DC73",
    width: 120,
    height: 77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.2645988,69.8173828C19.9263,69.8173828,14.085,58.4735985,14.085,42.642601 c0-20.7407017,9.7352991-35.6402016,28.8675995-35.6402016c3.3863029,0,6.4336014,0.4233999,8.9737015,1.0162005 l-1.8628006,10.1585999C48.455101,17.5,45.3227997,16.7378006,41.8521004,16.7378006 c-8.3809013,0-14.4761009,6.6879997-15.3227997,18.7094994c2.0317001-1.7784004,5.9258003-4.0634995,12.3598976-4.0634995 c9.9047012,0,17.8623009,6.517601,17.8623009,17.6923981C56.7514992,61.0126991,48.7938995,69.8173828,36.2645988,69.8173828z M35.0796013,40.7803001c-3.8096008,0-6.8569012,1.4393997-8.0425014,3.3017006 c-0.6772003,1.0156975-0.6772003,3.3857994-0.6772003,5.1641006c0,5.6718979,3.3017006,11.1737976,9.3969021,11.1737976 c5.9257965,0,8.9736977-4.8251991,8.9736977-9.9892006C44.7304993,44.8437004,41.0054016,40.7803001,35.0796013,40.7803001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7333984,55.9336014v12.4443283H87.8817978V55.9336014H60.9608994v-11.089901L84.1563034,8.6107998h15.577095 v38.0102997h7.0263977v9.3125H99.7333984z M87.8817978,19.1084003h-0.1688995 c-0.2538986,1.0156002-1.9472961,4.6557999-4.3183975,8.3808994L71.205101,46.6211014h16.6766968V19.1084003z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine64);
export default __webpack_public_path__ + "static/media/line-64.91cbdc1a43fe0a8d431bbb10fe3a9064.svg";
export { ForwardRef as ReactComponent };